import { CommonLayoutComponent } from './components/commonlayouts/common-layout/common-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppointmentsComponent } from './components/appointments/appointments.component';
import { DashboardsComponent } from './components/dashboards/dashboards.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './services/auth.guard';
import { CommonLayoutModule } from './components/commonlayouts/common-layout/common-layout.module';
import { BackgroundFormComponent } from './components/background-form/background-form.component';
import { AdminBackgroundFormsComponent } from './components/admin-background-forms/admin-background-forms.component';
import { CreateAppointmentComponent } from './components/create-appointment/create-appointment.component';
import { AdminViewStudentObservationComponent } from './components/admin-view-student-observation/admin-view-student-observation.component';
import { BackgroundFormAdultComponent } from './components/background-form-adult/background-form-adult.component';
import { AdminBackgroundFormAdultComponent } from './components/admin-background-form-adult/admin-background-form-adult.component';

const routes: Routes = [
  // { path: '/', component: AppComponent },

  // { path: '', component: LoginComponent },
  { path: '', component: LoginComponent ,
  pathMatch: 'full'

},{
  path : 'login',
  component : LoginComponent
},

  {
    path: 'create-appointment',
    component: CreateAppointmentComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'background-form',
    component: BackgroundFormComponent
    // pathMatch: 'full'
    // canActivate: [AuthGuard],
  },

  {
    path: 'background-form-adult',
    component: BackgroundFormAdultComponent
    // pathMatch: 'full'
    // canActivate: [AuthGuard],
  },
  {
    path: 'admin-background-form-adult/:appointmentId',
    component: AdminBackgroundFormAdultComponent
    // pathMatch: 'full'
    // canActivate: [AuthGuard],
  },
  {
    path: 'admin-background-form/:appointmentId',
    component: AdminBackgroundFormsComponent
    // pathMatch: 'full'
    // canActivate: [AuthGuard],
  },
  
  {
    path: 'view-student-observation/:id',
    component: AdminViewStudentObservationComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  {
    path: '',
    component: CommonLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            './components/commonlayouts/common-layout/common-layout.module'
          ).then((m) => m.CommonLayoutModule),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
